
import { TAO_KOE, TaoToaster } from '../libs/';
import UserCentrics from './usercentrics';

class ZopimHandlerClass {
	loadWidget() {
		// Already tried to load zopim once.
		if ( this.promise ) {
			return this.promise;
		}

		// Zopim was already loaded somewhere else.
		if ( window.$zopim ) {
			return new Promise( ( resolve ) => {
				window.$zopim( () => resolve( window.$zopim ) );
			} );
		}

		return this.promise = new Promise( ( resolve ) => {
			( function( d, s ) {
				const z = window.$zopim = function( c ) {
						z._.push( c );
					},
					$ = z.s = d.createElement( s ),
					e = d.getElementsByTagName( s )[ 0 ];

				z.set = function( o ) {
					z.set._.push( o );
				};
				z._ = [];
				z.set._ = [];

				$.async = ! 0;
				$.setAttribute( 'charset', 'utf-8' );
				$.src = 'https://v2.zopim.com/?2J332wEVnatB6p4Y44UlJooLXmmJvpH1'; z.t = +new Date;
				$.type = 'text/javascript'; e.parentNode.insertBefore( $, e );
			} )( document, 'script' );

			window.$zopim( () => resolve( window.$zopim ) );
		} ).then( ( $zopim ) => {
			// Apply Gigasport Styles.
			if ( document.documentElement.classList.contains( 'style_gigasport' ) ) {
				$zopim.livechat.theme.setColor( '#ED7F00' ); // gigasport orange
				$zopim.livechat.theme.reload(); // apply new theme settings
			}

			// Customize Zopim.
			document.body.classList.add( 'en_customize_zopim' );
			return $zopim;
		} );
	}

	showChat() {
		return this.loadWidget().then( ( $zopim ) => {
			$zopim.livechat.window.show();
			return $zopim;
		} );
	}

	onClick() {
		const popupEl = document.getElementById( 'popup_customconsent_zendesk' );
		if ( this.hasConsent() ) {
			this.showChat();
		} else if ( popupEl ) {
			TAO_KOE.open_popup( popupEl ).then( ( service ) => {
				if ( 'Zendesk' === service && this.hasConsent() ) {
					this.showChat();
				}
			} );
		} else {
			TaoToaster.toast( 'Der Chat konnte nicht geladen werden!', 'error' );
		}
	}

	hasConsent() {
		if ( window.UC_UI ) {
			const service = window.UC_UI.getServicesBaseInfo().find( ( { name } ) => 'Zendesk' === name );
			if ( service && 'consent' in service ) {
				return service.consent.status;
			}
		}

		return false;
	}
}

const ZopimHandler = new ZopimHandlerClass();

TAO_KOE.ready( 'zopim.js', () => {
	const checkConsentAvailable = new Promise( ( resolve ) => {
		const popupEl = document.getElementById( 'popup_customconsent_zendesk' );
		if ( popupEl ) {
			return resolve( true );
		}

		window.addEventListener( 'UC_GENERAL', ( ev ) => {
			if ( ev.detail && ev.detail.Zendesk ) {
				resolve( true );
			}
		} );
	} );

	Promise.race( [
		UserCentrics.ready(),
		new Promise( ( resolve ) => setTimeout( () => resolve(), 3000 ) ),
	] ).then( () => {
		const badgeEls = Array.from( document.getElementsByClassName( 'en_chat_badge' ) );
		badgeEls.forEach( ( badgeEl ) => {
			// Only show the Button if either consent is given, or the popup for consent is available.
			checkConsentAvailable.then( () => {
				badgeEl.classList.add( 'en_is_visible' );
			} );

			badgeEl.addEventListener( 'click', ( ev ) => {
				ev.preventDefault();
				ZopimHandler.onClick();
			} );
		} );
	} );
} );

// Expose.
window.KOE_Zopim_Handler = ZopimHandler;

// Export.
export default ZopimHandler;
